import { GoogleMap, LoadScript, TrafficLayer } from "@react-google-maps/api";
import React, { useContext, useMemo } from "react";
import { contexto } from "./CustomProvider";

const containerStyle = {
    width: "100%",
    height: "100vh",
};

export default function TrafficMap() {
    const { thisDeviceData } = useContext(contexto);
    const location = thisDeviceData?.location;

    const center = useMemo(() => {
        if (!location) {
            return {
                lat: -24.489616,
                lng: -46.675304,
            };
        }

        return {
            lat: Number(location.latitude),
            lng: Number(location.longitude),
        };
    }, [location]);


    if (!center) {
        return <div>Cargando ubicación…</div>;
    }

    return (
        <LoadScript googleMapsApiKey={"AIzaSyAD6_lw_djitCmUxEI8WyNyjvonlUTT57E"}>
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={center}
                zoom={12}
                options={{
                    streetViewControl: false,
                    mapTypeControl: false,
                    fullscreenControl: false,
                }}
            >
                <TrafficLayer autoUpdate />
            </GoogleMap>
        </LoadScript >
    );
}
